require('core-js/features/map');
//require('core-js/features/set');

import React   from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import 'whatwg-fetch';

import {LARGE, Size, SMALL} from "./App/PlayerReducer";
import { style } from './CSSLoad';

let PromiseCSS:Promise<void>;

const DN = ()=>{

    let founded = false;



    for (const em of   Array.prototype.slice.call( document.getElementsByTagName('link'), 0))
    {
        if (em.href && em.href.indexOf('radiacz-player.css') >= 0)
        {
            PromiseCSS = Promise.resolve();
            founded = true;
            break;
        }
    }

    if (!founded) {
        const css:string[] = [];
        switch (document.location.hostname) {
            case 'home.radia.cz':
                css.push('https://home.radia.cz/simpleplayer/radiacz-player.css?' + 'hash=' + __webpack_hash__);
                break;
            case 'radia.cz':
            default:
                css.push('https://radia.cz/simpleplayer/radiacz-player.css?' + 'hash=' + __webpack_hash__);
                break;
        }
        PromiseCSS = style.import(css);
    }
    return PromiseCSS;
}






const radiaczplayer = (id: string|HTMLElement) => {

    const element = typeof id === 'string' ? document.getElementById(id) : id;
    let velikost: Size = LARGE;
    let styleLoaded = false;

    let matched = document.location.search.match(/size=([^&]+)/)

    if (!matched)
        matched=[''];
    if (element) {

        switch (matched[1] || element.dataset.size  ) {
            case LARGE:
                velikost = LARGE;
                break;
            case SMALL:
                velikost = SMALL;
                break;
            default:
                velikost = LARGE;
                break;
        }


        DN().then(()=>
        {

            ReactDOM.render(<React.StrictMode>
                <App velikost={velikost} />
            </React.StrictMode>, element)
        })
    }
}
// @ts-ignore
window.radiaczplayer = radiaczplayer;

document.addEventListener('DOMContentLoaded', function(ev) {
    radiaczplayer('radiacz-prehravac');
});


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
